import type { CSSProperties, ReactNode } from 'react';
import { sflRadius } from '../tokens';
import { useSflColors } from '../useSflColors';

type Props = {
  children: ReactNode;
  variant?: 'default' | 'row';
  onPress?: () => void;
  className?: string;
  style?: CSSProperties;
};

export default function SflCard({ children, variant = 'default', onPress, className = '', style }: Props) {
  const colors = useSflColors();
  const padding = variant === 'row' ? 12 : 16;

  const baseStyle: CSSProperties = {
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.border2,
    borderRadius: sflRadius.lg,
    padding,
    transition: 'border-color 150ms ease, box-shadow 150ms ease, opacity 150ms ease',
    ...style,
  };

  if (onPress) {
    return (
      <button
        type="button"
        onClick={onPress}
        className={`w-full text-left ${className}`}
        style={baseStyle}
        onMouseDown={(e) => {
          e.currentTarget.style.opacity = '0.96';
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={className} style={baseStyle}>
      {children}
    </div>
  );
}
